module.exports = __webpack_public_path__ + "media/images/icon-svg/shopping-bag-white-93c6519643627dc52c22a2ec02f31341.svg";